import React from 'react';
import { motion } from 'framer-motion';
const management = [{
  initials: 'MH',
  name: 'Morten Hjelmsø',
  role: 'Founder & CEO',
  roleColor: 'text-purple-600',
  gradient: 'from-purple-500 to-indigo-600',
  tags: ['CAD-Kompagniet', 'Agnitio', 'Anthill Agency'],
  bio: 'Proven serial entrepreneur with multiple exits in pharma/tech. +25 year international Pharma expertise.'
}, {
  initials: 'RdS',
  name: 'Richard dos Santos',
  role: 'Co-Founder & CCO/CTO',
  roleColor: 'text-blue-600',
  gradient: 'from-blue-500 to-cyan-500',
  tags: [],
  bio: "Experienced business leader with a strong technical background. Drives Snakker's operational and technological development."
}, {
  initials: 'MHH',
  name: 'Martin Hoyer-Hansen',
  role: 'CFO',
  roleColor: 'text-emerald-600',
  gradient: 'from-emerald-400 to-teal-500',
  tags: [],
  bio: 'Executive with extensive background in venture, scale-ups and board management.'
}];
const board = [{
  initials: 'PH',
  name: 'Patrick Howaldt',
  role: 'Chairman, Colony Denmark ApS',
  roleColor: 'text-amber-700',
  gradient: 'from-amber-400 to-orange-500',
  bio: 'Director at Phase One A/S; brings entrepreneurial drive and strategic oversight to tech and growth-oriented organizations.',
  photo: null
}, {
  initials: 'MW',
  name: 'Mikael Worning',
  role: 'Board Chairman & Medtech Executive',
  roleColor: 'text-amber-700',
  gradient: 'from-amber-400 to-orange-500',
  bio: 'Former Regional CEO (Americas) at Demant; chairs CellaVision AB & Qufora A/S. Expert in scaling innovative medical technologies.',
  photo: null
}];
const advisors = [{
  initials: 'MG',
  name: 'Michael Gladstone',
  role: 'Former Global President – Inflammation & Immunology, Pfizer',
  roleColor: 'text-rose-600',
  gradient: 'from-rose-400 to-pink-500',
  bio: 'Spearheaded global strategy for game-changing therapies, prior Global President, Internal Medicine.',
  photo: null
}, {
  initials: 'MH',
  name: 'Mike Hayes',
  role: 'Managing Director, Insight Partners',
  roleColor: 'text-rose-600',
  gradient: 'from-rose-400 to-pink-500',
  bio: 'Former Navy SEAL Commander & NSC leader; COO at VMware. Invests in high-growth software with $90B+ AUM.',
  photo: null
}];
export function TeamSlide() {
  return <div className="h-full flex flex-col gap-4 justify-center" data-id="element-476">
      {/* Management Team */}
      <div data-id="element-477">
        <motion.div initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="flex items-center gap-2 mb-3" data-id="element-478">
          <div className="w-2.5 h-2.5 rounded-full bg-purple-500" data-id="element-479" />
          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest" data-id="element-480">
            Management Team
          </p>
        </motion.div>
        <div className="grid grid-cols-3 gap-4" data-id="element-481">
          {management.map((person, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1 + i * 0.1
        }} className="p-5 rounded-2xl bg-gray-50 border-l-4 border-l-purple-400 border border-gray-200 flex flex-col gap-3" data-id="element-482">
              <div className="flex items-center gap-3" data-id="element-483">
                <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${person.gradient} p-0.5 shrink-0`} data-id="element-484">
                  <div className="w-full h-full rounded-full bg-white flex items-center justify-center text-xs font-bold text-gray-800" data-id="element-485">
                    {person.initials}
                  </div>
                </div>
                <div data-id="element-486">
                  <h3 className="text-sm font-bold text-gray-900 leading-tight" data-id="element-487">
                    {person.name}
                  </h3>
                  <p className={`text-xs font-medium ${person.roleColor}`} data-id="element-488">
                    {person.role}
                  </p>
                </div>
              </div>
              {person.tags.length > 0 && <div className="flex flex-wrap gap-1.5" data-id="element-489">
                  {person.tags.map(tag => <span key={tag} className="px-2 py-0.5 rounded-md bg-purple-50 border border-purple-100 text-[10px] font-medium text-purple-600" data-id="element-490">
                      {tag}
                    </span>)}
                </div>}
              <p className="text-xs text-gray-500 leading-snug" data-id="element-491">{person.bio}</p>
            </motion.div>)}
        </div>
      </div>

      {/* Board & Advisors row */}
      <div className="grid grid-cols-2 gap-5" data-id="element-492">
        {/* Board */}
        <div data-id="element-493">
          <motion.div initial={{
          opacity: 0,
          y: -6
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="flex items-center gap-2 mb-3" data-id="element-494">
            <div className="w-2.5 h-2.5 rounded-full bg-amber-500" data-id="element-495" />
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest" data-id="element-496">
              Board of Directors
            </p>
          </motion.div>
          <div className="grid grid-cols-2 gap-3" data-id="element-497">
            {board.map((person, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5 + i * 0.08
          }} className="p-3 rounded-xl bg-amber-50 border-l-4 border-l-amber-400 border border-amber-100 flex flex-col gap-2" data-id="element-498">
                <div className="flex items-center gap-2" data-id="element-499">
                  <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${person.gradient} p-0.5 shrink-0`} data-id="element-500">
                    <div className="w-full h-full rounded-full bg-white flex items-center justify-center text-[10px] font-bold text-gray-800" data-id="element-501">
                      {person.initials}
                    </div>
                  </div>
                  <div data-id="element-502">
                    <h4 className="text-xs font-bold text-gray-900 leading-tight" data-id="element-503">
                      {person.name}
                    </h4>
                    <p className={`text-[10px] font-medium ${person.roleColor} leading-tight`} data-id="element-504">
                      {person.role}
                    </p>
                  </div>
                </div>
                <p className="text-[10px] text-gray-400 leading-snug" data-id="element-505">
                  {person.bio}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Advisors */}
        <div data-id="element-506">
          <motion.div initial={{
          opacity: 0,
          y: -6
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="flex items-center gap-2 mb-3" data-id="element-507">
            <div className="w-2.5 h-2.5 rounded-full bg-rose-500" data-id="element-508" />
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest" data-id="element-509">
              Advisors
            </p>
          </motion.div>
          <div className="grid grid-cols-2 gap-3" data-id="element-510">
            {advisors.map((person, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.6 + i * 0.08
          }} className="p-3 rounded-xl bg-rose-50 border-l-4 border-l-rose-400 border border-rose-100 flex flex-col gap-2" data-id="element-511">
                <div className="flex items-center gap-2" data-id="element-512">
                  <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${person.gradient} p-0.5 shrink-0`} data-id="element-513">
                    <div className="w-full h-full rounded-full bg-white flex items-center justify-center text-[10px] font-bold text-gray-800" data-id="element-514">
                      {person.initials}
                    </div>
                  </div>
                  <div data-id="element-515">
                    <h4 className="text-xs font-bold text-gray-900 leading-tight" data-id="element-516">
                      {person.name}
                    </h4>
                    <p className={`text-[10px] font-medium ${person.roleColor} leading-tight`} data-id="element-517">
                      {person.role}
                    </p>
                  </div>
                </div>
                <p className="text-[10px] text-gray-400 leading-snug" data-id="element-518">
                  {person.bio}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
}